<template>
  <section>
    <ResourcesMonitoringHeader />
    <ResourcesMonitoringIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ResourcesMonitoring',
  components: { ...partials }
}
</script>
